import styled from 'styled-components';

const DrawerMenu__Group = styled.div<{ isFirstGroup: boolean }>`
  ${({ isFirstGroup, theme }) => (!isFirstGroup ? `
     border-top: 1px solid ${theme.colors.lighterGray};
     padding-top: ${theme.space.tiny};
  ` : `
     padding-bottom: ${theme.space.tiny};
  `)}
`;

const DrawerMenu__Group__Name = styled.div`
    padding: ${({ theme }) => theme.space.small};
    color: #99a1ab;
    font-size: 12px;
    white-space: nowrap;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

const DrawerMenu__Group__Items = styled.div``;

const DrawerMenu__Item = styled.div`
    & > div {
      padding: 12px 5px;
    }
`;

export const Styled = {
  DrawerMenu__Group,
  DrawerMenu__Group__Name,
  DrawerMenu__Group__Items,
  DrawerMenu__Item,
};
